module.exports = __webpack_public_path__ + "static/media/aw.ab68008c.svg";